export default __webpack_public_path__ + "static/media/logo.fd94a696.webp";